import React from 'react';
import { connect } from 'react-redux';
import MenuItemQuantitySelection from './MenuItemQuantitySelection';
import { quantityAdd, quantitySubtract } from '../../../actions/cartItem';

class MenuItemInformation extends React.Component {

    render() {
        return (
            <div>
                {(this.props.item && this.props.item.app_view_image != null && this.props.item.app_view_image.trim() != '') && <img
                    src={this.props.assets_url + this.props.item.app_view_image}
                    className="menu-item-header-image"
                />}
                {(!this.props.item || !this.props.item.app_view_image) && <div className="menu-item-empty-image" />}

                <div className="menu-item-information-window">
                    <div>
                        {(this.props.isCustomPizza) ? <p className="menu-item-name">Build Your Own Pizza.</p> : <p className="menu-item-name">{this.props.item.name}</p>}
                    </div>

                    <div>
                        {(!this.props.isCustomPizza && this.props.item.description != null) && <p className="menu-item-description">{this.props.item.description}</p>}
                        {(this.props.isCustomPizza) && <p className="menu-item-description">Enter your pizza size and how many toppings you want.</p>}
                    </div>

                    { (this.props.isOpen == "1") && (
                        <div className="quantity-buttons-wrapper-food-modal">
                            <MenuItemQuantitySelection
                                quantity={this.props.quantity}
                                quantitySubtract={() => { this.props.dispatch(quantitySubtract()) }}
                                quantityAdd={() => { this.props.dispatch(quantityAdd()) }}
                            />
                        </div>
                    ) }
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state) => {

    return {
        isOpen: state.currentLocation.info.location.open,
        assets_url: state.currentLocation.info.assets_url,
        quantity: state.cartItem.quantity
    };
};

export default connect(mapStateToProps)(MenuItemInformation);